import { css, SerializedStyles } from '@emotion/core';
import styled from '@emotion/styled';
import { Typography, Card as MuiCard } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const cssAlignContent = (theme: ICustomTheme): SerializedStyles =>
  css({
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  });
export const cssDescription = (theme: ICustomTheme): SerializedStyles =>
  css({
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1rem',
    },
  });
export const cssDescriptionContainer = (
  theme: ICustomTheme,
): SerializedStyles =>
  css({
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
      width: '100%',
    },
  });
export const cssNegativeTop = (theme: ICustomTheme): SerializedStyles =>
  css({
    marginTop: -theme.spacing(1),
  });
export const cssSecondary = (theme: ICustomTheme): SerializedStyles =>
  css({
    color: theme.colors.paletteFromBO.primary,
  });

export const Card = styled(MuiCard)<Theme>(({ theme }) => ({
  boxShadow: theme.shadows[3],
  color: theme.colors.grey.dark,
  marginBottom: theme.spacing(5),
  padding: `${theme.spacing(6)}px 9.25vw`,
  textAlign: 'center',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(2.5),
    padding: theme.spacing(3, 2),
  },
}));

export const Description = styled(Typography)<{
  theme: ICustomTheme;
  isBold?: boolean;
}>(({ theme, isBold = false }) => ({
  display: 'block',
  marginBottom: theme.spacing(1),
  fontWeight: isBold
    ? theme.typography.fontWeightBold
    : theme.typography.fontWeightRegular,
}));

export const ErrorMessageContainer = styled.div<Theme>(({ theme }) => ({
  color: theme.colors.error.main,
  display: 'block',
  height: theme.spacing(1),
}));

export const SizeRecommendations = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.grey.light,
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.2rem',
  },
}));

export const Subtitle = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.paletteFromBO.main,
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: 0,
  paddingBottom: 0,
}));

export const Title = styled(Typography)<Theme>(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  color: theme.colors.paletteFromBO.main,
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(3),
  },
}));

export const Wrapper = styled(Typography)<Theme>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
  marginTop: theme.spacing(2),
}));
